export const cash = {
  'cash.title': 'إغلاق الصندوق',
  'cash.account': 'الحساب',
  'cash.date': 'اليوم',
  'cash.opening': 'الرصيد الافتتاحي',
  'cash.openingHint': 'آخر جرد مُغلق والحركات بعده',
  'cash.in': 'المقبوض',
  'cash.out': 'المصروف',
  'cash.expected': 'المتوقع في الصندوق',
  'cash.expectedHint': 'الافتتاحي + المقبوض − المصروف',
  'cash.movements': 'حركة اليوم',
  'cash.noMovements': 'لا حركات في هذا اليوم',
  'cash.entries': 'عدد الحركات: {n}',
  'cash.col.source': 'البيان',
  'cash.col.method': 'الطريقة',
  'cash.col.count': 'العدد',
  'cash.col.amount': 'المبلغ',
  'cash.direction.IN': 'داخل',
  'cash.direction.OUT': 'خارج',
  'cash.pending': '{n} (تحويلات أو صكوك) بانتظار التسوية بقيمة {amount}؛ لا تدخل الحساب حتى تُسوّى.',
  'cash.pendingLink': 'عرض ما بانتظار التسوية',
  'cash.counted': 'النقد المعدود فعلياً',
  'cash.difference': 'الفرق',
  'cash.balanced': 'مطابق',
  'cash.shortage': 'عجز',
  'cash.surplus': 'زيادة',
  'cash.enterCount': 'أدخل المبلغ المعدود لحساب الفرق',
  'cash.note': 'ملاحظة الفرق',
  'cash.notePlaceholder': 'اشرح سبب العجز أو الزيادة',
  'cash.noteRequired': 'الملاحظة مطلوبة عند وجود فرق',
  'cash.close': 'إغلاق اليوم وتوقيع المحاسب',
  'cash.closeTitle': 'إغلاق يوم {date}؟',
  'cash.closeBody': 'بعد الإغلاق يُقفل اليوم، وأي تصحيح يتم بقيد عكسي فقط.',
  'cash.closedOk': 'أُغلق الصندوق ووُقّع',
  'cash.closedBy': 'أُغلق ووُقّع باسم {name} — {at}. اليوم مقفل للتعديل.',
  'cash.anotherUser': 'مستخدم آخر',
  'cash.lockNote': 'بعد الإغلاق يُقفل اليوم، وأي تصحيح يتم بقيد عكسي فقط.',
  'cash.onlyDesk': 'يُغلق يومياً الصندوق النقدي فقط؛ الحسابات المصرفية والمحافظ تُعرض للاطلاع.',
  'cash.readOnly': 'يُغلق الصندوقَ المديرُ أو المحاسب؛ يمكنك الاطلاع فقط.',
  'cash.history': 'سجل الإغلاقات',
  'cash.historyEmpty': 'لم يُغلق هذا الحساب من قبل',
  'cash.col.day': 'اليوم',
  'cash.col.opening': 'الافتتاحي',
  'cash.col.in': 'داخل',
  'cash.col.out': 'خارج',
  'cash.col.expected': 'المتوقع',
  'cash.col.counted': 'المعدود',
  'cash.col.difference': 'الفرق',
  'cash.col.note': 'ملاحظة',
  'cash.noAccounts': 'لا توجد حسابات نقدية',
  'cash.noAccountsBody': 'أضف صندوقاً نقدياً من الإعدادات.',
  'cash.notClosed': 'لم يُغلق هذا اليوم بعد.',
  'cash.countTitle': 'جرد الصندوق',
  'cash.col.closedBy': 'وقّعه',
} as const;
